import { SitkaModule } from "olio-sitka"
import { call, put, select } from 'redux-saga/effects'

export default class NavigationModule extends SitkaModule {
    moduleName = "navigation"
    defaultState = {
        redirect: null,
        location: null,
    };

    constructor() {
        super()
        this.updateState = this.updateState.bind(this)
    }
    
    *handleSetRedirect(redirect) {
        yield call(this.updateState, {...redirect})
    }

    *handleClearRedirect() {
        yield call(this.updateState, { ...this.defaultState })
    }

    *updateState(newState) {
        yield put(
            this.setState({
                ...(yield select(this.getCurrentState)),
                ...newState,
            })
        )
    }

    getCurrentState(state) {
        return state.navigation
    }
}


// WEBPACK FOOTER //
// ./src/redux/modules/navigation.js